import { useEffect, useState } from 'react';
import { ensurePlaybackClockRunning, playbackClock } from '@/lib/playbackClock';

interface PlayheadSnapshot {
  time: number;
  duration: number;
  playing: boolean;
  speed: number;
}

function snapshot(): PlayheadSnapshot {
  return {
    time: playbackClock.time,
    duration: playbackClock.duration,
    playing: playbackClock.playing,
    speed: playbackClock.speed,
  };
}

/** Polls the playback clock at a fixed rate for React components that display it (scrubber, status bar) rather than every animation frame. */
export function useThrottledPlayhead(hz = 10): PlayheadSnapshot {
  const [value, setValue] = useState(snapshot);

  useEffect(() => {
    ensurePlaybackClockRunning();
    const interval = window.setInterval(() => setValue(snapshot()), 1000 / hz);
    return () => window.clearInterval(interval);
  }, [hz]);

  return value;
}
